<template lang="pug">
  .restart
    .restart__content
      .restart__title Вы потеряли одного бобра
      button.restart__button(@click="$emit('restart')") Продолжить
</template>

<script>
export default {
  name: 'Restart',
};
</script>

<style lang="scss">
  .restart {
    @include game-window;
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/Restart.vue